<template>
  <span class="resource-container">
    <div v-for="lesson in lessons">
      <span v-if="lesson.data.date_in <= today">
        <resource-store
          :resource="lesson.resources"
          @click="pushResource()"
        ></resource-store>
      </span>
      <span v-else>
        <p style="font-size: 1.2rem; color: grey; font-weight: 700">
          Inicie el:
          {{
            moment(lesson.data.date_in)
              .locale("es")
              .format("LLL")
          }}
        </p>
        <p style="font-size: 1.2rem; color: #7465E4; font-weight: 700">
          En:
          {{
            moment(lesson.data.date_in)
              .locale("es")
              .startOf("day")
              .fromNow()
          }}
        </p>
      </span>
    </div>
  </span>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import ResourceStore from "./Resources/resourceStore.vue";
export default {
  name: "lessonResource",
  components: {
    ResourceStore
  },
  props: ["lessons"],
  created() {},
  data() {
    return {};
  },
  computed: {
    ...mapState,
    ...mapGetters(["course/lessons_all", "today", "course/MODULE_SELECTED"])
  },
  methods: {
    pushResource: function() {
      var arr = this.lessons;
      var resource = [...arr].shift();
      this.$store.commit("course/allResources", resource);
    }
  },
  watch: {
    MODULE_SELECTED(new_value, old_value) {
      if (new_value !== old_value) {
        this.pushResource();
      }
    }
  }
};
</script>
<style scoped>
.resource-container {
  display: flex;
  flex-direction: column;
}
.item-resource-name {
  width: 100%;
  display: flex;
  padding: 10px 10px;

  font-size: 1.2rem;
  cursor: pointer;
  background-color: #fff;
}
.item-resource-name:hover {
  background-color: #fff;
}
</style>
